import React from 'react';
import PropTypes from 'prop-types';

const UiExpandCollapseDownPath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M8 8.795l4.42-4.419a.5.5 0 0 1 .707 0l.883.884a.5.5 0 0 1 0 .707l-5.656 5.657a.498.498 0 0 1-.708 0L1.99 5.967a.5.5 0 0 1 0-.707l.883-.884a.5.5 0 0 1 .708 0L8 8.796z"
    />
  );
};

UiExpandCollapseDownPath.propTypes = {
  fill: PropTypes.string,
};

export default UiExpandCollapseDownPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/ui-controls/ui-expand-collapse-down.jsx